module.exports = __webpack_public_path__ + "static/media/18ECA14.7d1baa79.jpg";